import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetDashboardSummary = async (params?: {
  start_date?: string;
  end_date?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/dashboard/summary`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load dashboard summary.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
